import React, {useState} from 'react';
import { useReport } from '../../Data/Admin';
import Chart from '../../Components/Chart';
import { PageLoading } from '../../Components/Loading';
import Section from '../../Components/Containers/Section';
import Button from '../../Components/Button/Button';
import Form, { Actions, Radio } from '../../Components/Form';
import { selectableDateRanges, selectablePeriods } from '../../Data/DateRanges';
import Modal from '../../Components/Modal';
import { usePreference } from '../../Data/Preference';

const Report = () => {
    const [range, setRange] = usePreference('admin-report-range', 'thisMonth');
    const [interval, setInterval] = usePreference('admin-report-interval', 'date');
    const [optionsOpen, setOptionsOpen] = useState(false);
    const {report, refresh} = useReport(range, interval);

    useState(() => {
        refresh();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [range, interval]);

    return <>
        <Section title="Stats"
            button={<Button theme="light" icon="ChartSimple" zeroMargin onClick={() => setOptionsOpen(true)} />}
        >
            <div style={{ height: '40vh' }}>
                {report ? <Chart type="Bar" data={getChartData(report)} options={chartFormat} /> : <PageLoading />}
            </div>
        </Section>

        <ChartOptions {...{optionsOpen, setOptionsOpen, range, setRange, interval, setInterval}} />
    </>
}

const ChartOptions = ({optionsOpen, setOptionsOpen, range, setRange, interval, setInterval}) => {
    const saveChanges = (data) => {
        setRange(data.range);
        setInterval(data.interval);
    }

    return <Modal isOpen={optionsOpen} setIsOpen={setOptionsOpen} title="Chart Options">
        <Form data={{range, interval}} onSubmit={saveChanges} closeModalOnSubmit>
            <Radio name="range" label="Range" options={selectableDateRanges.filter(s => s.value !== 'allTime')} />
            <Radio name="interval" label="Period" options={selectablePeriods} />
            <Actions submit={{label: 'Change'}} />
        </Form>
    </Modal>
}

const chartFormat = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
        title: {
            display: false,
            text: 'Stats',
        },
        // legend: {
        //     labels: {
        //         filter: filterLegend,
        //     }
        // }
    },
    scales: {
        y: {
            position: 'left',
            min: 0,
            suggestedMax: 10,
            title: {
                text: 'Others',
                display: true,
            }
        },
        y1: {
            position: 'right',
            min: 0,
            suggestedMax: 100,
            title: {
                text: 'Customers',
                display: true,
            }
        },
    },
};

const getChartData = (data) => {
    return {
        labels: data.activeBusinesses.map(ab => ab.grouping),
        datasets: [
            {
                label: 'Active Businesses',
                data: data.activeBusinesses.map(ab => ab.count),
                backgroundColor: '#dc3545',
                yAxisID: 'y',
            },
            {
                label: 'New Users',
                data: data.userRegistrations.map(u => u.count),
                backgroundColor: '#28a745',
                yAxisID: 'y',
            },
            {
                label: 'Active Users',
                data: data.activeUsers.map(c => c.count),
                backgroundColor: '#314695',
                yAxisID: 'y',
            },
            {
                label: 'Payments',
                data: data.payments.map(c => c.count),
                backgroundColor: '#e83e8c',
                yAxisID: 'y',
                hidden: true,
            },
            {
                label: 'New Customers',
                data: data.customers.map(c => c.count),
                backgroundColor: '#6f42c1',
                yAxisID: 'y1',
                hidden: true,
            },
        ]
    };
}

export default Report;
